export function calculatePercentage(num: number, total: number) {
  if (total === 0) return 0;
  return (num / total) * 100;
}
